/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeDto as DigiworkMaitreDPosDtoEmployeeEmployeeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/employee-dto';

export interface ListAllEmployeesForVenue_1$Params {
  VenueId?: string;
}

export function listAllEmployeesForVenue_1(http: HttpClient, rootUrl: string, params?: ListAllEmployeesForVenue_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>>> {
  const rb = new RequestBuilder(rootUrl, listAllEmployeesForVenue_1.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>>;
    })
  );
}

listAllEmployeesForVenue_1.PATH = '/api/gmn/Employee/listallemployeesforvenue';
